"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("mktCourbesTauxService", function ($http, chartUtils, $translate, tlColors) {
  return {
    getCompteCourbeTauxCurrency: function getCompteCourbeTauxCurrency($session) {
      return $http.get('/rest/marche/courbe-taux/devises').then(function (response) {
        var courbesTauxDevises = response.data;
        var devise = $session.getCompte().devise;
        console.log(courbesTauxDevises);
        console.log(devise);
        if (_.indexOf(courbesTauxDevises, devise) === -1) {
          console.log("fallback EUR");
          return 'EUR';
        }
        return devise;
      });
    },
    getCourbeTauxChartSeries: function getCourbeTauxChartSeries(courbeId, date1, date2, date3, avecCourbeOAT) {
      return $http.get('/rest/marche/courbe-taux', {
        params: {
          courbeId: courbeId,
          date1: date1,
          date2: date2,
          date3: date3,
          avecCourbeOAT: avecCourbeOAT
        }
      }).then(function (response) {
        var data = response.data;
        var serie = [{
          name: date1 == null ? $translate('marche.DernierFixing') : moment(date1).format('DD/MM/YYYY'),
          data: chartUtils.mapAndFilter(data, "maturite", "fixingCourant.valeur"),
          zIndex: 4,
          color: tlColors.COURBE_TAUX_1
        }];
        if (avecCourbeOAT) {
          serie.push({
            name: $translate('marche.OATEquivalente'),
            data: chartUtils.mapAndFilter(data, "maturite", "oatCourant.valeur"),
            zIndex: 3,
            color: tlColors.GREY2
          });
        }
        if (date1 == null || date2 != null) serie.push({
          name: date2 == null ? $translate('marche.1Mois') : moment(date2).format('DD/MM/YYYY'),
          data: chartUtils.mapAndFilter(data, "maturite", "fixing1Mois.valeur"),
          zIndex: 2,
          color: tlColors.COURBE_TAUX_2
        });
        if (date1 == null || date3 != null) serie.push({
          name: date3 == null ? $translate('marche.6Mois') : moment(date3).format('DD/MM/YYYY'),
          data: chartUtils.mapAndFilter(data, "maturite", "fixing6Mois.valeur"),
          zIndex: 1,
          color: tlColors.COURBE_TAUX_3
        });
        return serie;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/courbes-taux/mktCourbesTauxService.js
// module id = 2836
// module chunks = 13